import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";

export const messageTemplatesApi = async ({ token, uidPartner }) => {
  const response = await httpClient(
    "GET",
    `${ApiEndpoint}rcs/message-templates/${uidPartner}`,
    {},
    token,
  );

  return response.data;
};

export const messageTemplateDetail = async ({ token, uidPartner, uuid }) => {
  const response = await httpClient(
    "GET",
    `${ApiEndpoint}rcs/message-templates/${uidPartner}/detail/${uuid}`,
    {},
    token,
  );
  return response?.data[0];
};

export const createMessageTemplate = async ({ token, uidPartner, data }) => {
  const response = await httpClient(
    "POST",
    `${ApiEndpoint}rcs/message-templates/${uidPartner}`,
    data,
    token,
  );

  return response.data;
};

export const updateMessageTemplate = async ({
  token,
  uidPartner,
  uuid,
  data,
}) => {
  const response = await httpClient(
    "PUT",
    `${ApiEndpoint}rcs/message-templates/${uidPartner}/${uuid}`,
    data,
    token,
  );

  return response.data;
};

export const deleteMessageTemplate = async ({ token, uidPartner, uuid }) => {
  const response = await httpClient(
    "DELETE",
    `${ApiEndpoint}rcs/message-templates/${uidPartner}/${uuid}`,
    {},
    token,
  );

  return response.data;
};
